import { FieldTypes } from 'drapcode-constant';
import { findParentCollection } from '../../collectionTraits/utils';
import { fieldTraitTextContentOptions } from '../../dataGroup/traitsApi';
import { getCollectionFields } from '../../pluginComponentApi';

export const FluidPayBlock = (bm, category, label, type) => {
  bm.add(type, {
    label: `
    <svg width="100%" height="100%" viewBox="0 0 391 135" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
        <g id="Logo_2_">
            <g id="Group_2_">
                <g>
                    <path id="Shape_38_" d="M57.9,87C57.9,87 39.3,92.2 36.6,104C33.9,115.8 46.2,118.1 46.2,118.1C46.2,118.1 41.5,98.7 57.9,87" />
                    <path id="Shape_37_" d="M77.3,57.2C75,54.3 71.7,52.5 68,52.2L67.6,52.2C62.5,51.5 54.4,52 43.6,60.3C31.5,69.7 23.3,81.3 28.6,100.7C28.6,100.7 33.3,85.8 46.6,79.5C51.5,77.1 62.8,79 65.4,79.3C70.4,79.8 75.3,77.4 78.1,73.2C80.9,69 81.1,63.6 78.7,59.2C78.3,58.4 77.8,57.8 77.3,57.2Z" />
                    <path id="Shape_36_" d="M79.3,17.7C77.2,16 74.7,14.9 72,14.6L71.3,14.6C70.6,14.5 69.8,14.4 69.1,14.4L68.6,14.4C66.6,14.4 64.6,14.7 62.6,15.2C48.7,18.7 36.2,26.4 27,37.4C16.3,50.3 13.2,66.7 19.6,83.7C22.7,70.9 30.4,59.7 41.2,52.3C52.9,44 64,47.2 68.1,47.2C77.6,47.2 86.3,41 86.3,31.5C86.3,26.1 83.7,20.9 79.3,17.7Z" />
                    <path id="Shape_35_" d="M131.4,72.1L100.7,72.1L95.6,86L87.9,86L97.4,60.1C98.5,57.2 101,55 105.1,53.5C108.2,52.3 111.5,51.7 114.8,51.7L122.3,51.7L119.9,58.1C116,58.1 113.3,58.2 111.7,58.4C107.5,58.8 105.1,59.8 104.5,61.4L102.9,65.7L133.6,65.7L131.4,72.1Z" />
                    <path id="Shape_34_" d="M138.3,86L130.5,86L143.4,51.6L151.2,51.6L138.3,86Z" />
                    <path id="Shape_33_" d="M183.8,77.8C182.5,81.3 179.7,84 176.1,85C172.9,85.9 169.5,86.4 166.2,86.3L157.8,86.3C148.1,86.3 144.3,83.5 146.3,77.8L153.5,58.8L160.7,58.8L153.7,77.5C153.1,79.1 155.2,79.9 159.8,79.9L169,79.9C173.5,79.9 176,79.1 176.6,77.6L183.4,58.8L190.8,58.8L183.8,77.8Z" />
                    <path id="Shape_32_" d="M205.2,52.2C204.8,53.1 204.1,53.9 203.2,54.4C202.4,54.9 201.4,55.1 200.5,55.1C199.7,55.2 198.9,54.9 198.3,54.4C197.7,53.8 197.6,52.9 198,52.2C198.4,51.2 199.1,50.5 199.9,50C200.7,49.5 201.7,49.3 202.6,49.3C203.4,49.2 204.2,49.5 204.8,50.1C205.4,50.6 205.6,51.5 205.2,52.2Z" />
                    <path id="Shape_31_" d="M192.9,86L185.7,86L195.4,58.8L202.8,58.8L192.9,86Z" />
                    <path id="Shape_30_" d="M237.8,77.2C236.4,80.5 233.5,83.1 230,84.1C226.8,85.3 223.5,85.9 220.1,85.9L211.5,85.9C202,85.9 198.2,83.2 200.2,77.9L204,67.6C206.1,61.8 211.9,58.8 221.4,58.8L237.5,58.8L240.4,51.6L247.6,51.6L237.8,77.2ZM231.6,77.1L235.9,65.2L219.5,65.2C215.1,65.2 212.6,66 212,67.7L208.7,76.8C208,78.7 209.5,79.6 213.1,79.6L222.8,79.6C228,79.7 231,78.8 231.6,77.1Z" />
                    <path id="Shape_29_" d="M280,77.2C277.9,83.1 272.5,86 263.8,86L247,86L244.3,93.3L236.8,93.3L246.5,67.3C248.5,61.7 254.1,58.9 263.3,58.9L272.3,58.9C281.9,58.9 285.7,61.7 283.6,67.3L280,77.2ZM272.7,76.5L276.3,66.5C276.8,65.1 275.2,64.4 271.6,64.4L261.2,64.4C256.7,64.4 254.2,65.1 253.7,66.6L249.3,78.8L266.4,78.8C270,78.8 272.1,78 272.7,76.5Z" />
                    <path id="Shape_28_" d="M324,76.9C321.9,82.6 316.7,86.3 308.4,86.3L294.5,86.3C291.8,86.4 289.6,85.8 287.3,84.5C284.9,83.3 283.7,79.6 284.8,77.2L286,73.9C287.2,70.8 289.7,68.4 292.8,67.3C295.6,66.1 298.7,65.5 301.8,65.5L320.3,65.5C320.6,64.6 319.2,61.8 316.2,61.8L308.3,61.8L310.5,55.7L318.4,55.7C321.1,55.5 323.7,56.2 326,57.5C328.2,59 329,63.9 327.9,67L324,76.9ZM317.8,73.9L318.1,73.1L318.5,71.9L299.3,71.9C295.8,71.9 293.7,72.9 293,74.7L292.3,76.6C291.7,78.3 293.2,79.1 296.8,79.1L311.4,79.1C312.9,79.3 314.5,78.9 315.7,78C316.7,76.8 317.4,75.4 317.8,73.9Z" />
                    <path id="Shape_27_" d="M362.7,85.2C361.4,88.7 357.8,94.2 353.7,95.4C350.3,96.3 346.8,96.7 343.3,96.5L338.3,96.5L340.6,90.3L348.2,90.3C351,90.1 353.6,88.5 355.1,86.2L339,86.2C329.9,86.2 326.4,83.4 328.5,77.7L335.6,58.9L342.6,58.9L335.9,77.4C335.3,79 337.1,79.8 341.3,79.8L357.4,79.8L365.2,58.9L372.7,58.9L362.7,85.2Z" />
                </g>
            </g>
        </g>
        <g transform="matrix(0.0109979,0,0,0.0109979,373.199,46.9429)">
            <path d="M600.606,1007.22C376.7,1007.22 194.539,825.063 194.539,601.158C194.539,377.251 376.7,195.09 600.606,195.09C824.512,195.09 1006.67,377.251 1006.67,601.158C1006.67,825.063 824.512,1007.22 600.606,1007.22ZM944.307,257.457C852.502,165.65 730.439,115.09 600.606,115.09C470.773,115.09 348.71,165.65 256.905,257.457C165.098,349.262 114.539,471.325 114.539,601.158C114.539,730.99 165.098,853.053 256.905,944.859C348.71,1036.66 470.773,1087.22 600.606,1087.22C730.439,1087.22 852.502,1036.66 944.307,944.859C1036.11,853.053 1086.67,730.99 1086.67,601.158C1086.67,471.325 1036.11,349.262 944.307,257.457Z" />
            <path d="M595.498,579.631L502.025,579.631L502.025,394.182C523.06,391.92 549.766,390.79 582.144,390.79C682.482,390.79 732.67,422.08 732.67,484.645C732.67,547.97 686.939,579.631 595.498,579.631ZM712.033,613.556C775.158,586.416 806.721,541.944 806.721,480.121C806.721,433.389 786.48,396.443 746.023,369.304C705.547,342.166 650.92,328.596 582.144,328.596C536.015,328.596 483.817,333.508 425.548,343.296L425.548,872.505L502.025,872.505L502.025,638.432L599.139,638.432C677.627,638.432 727.814,716.457 749.666,872.505L826.143,872.505C813.188,791.09 798.412,732.286 781.834,696.104C765.238,659.917 741.965,632.408 712.033,613.556Z" />
        </g>
    </svg>
    <div>${label}</div>`,
    category: category,
    content: `
    <div data-gjs-type="fluid_pay">
      <div id="fluid-pay-container"></div>
      <button id="fluid-pay-btn" class="btn btn-primary" disabled="true">
        Pay with Fluid Pay
      </button>
    </div>`,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections } = config;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: `<svg height="10" viewBox="0 0 50 45" xmlns="http://www.w3.org/2000/svg">
          <g fill="#c3cfe9" fill-rule="evenodd">
          <path d="M102.473 32.722h4.489V14.934h-4.489zM124.39 18.268a7.376 7.376 0 00-2.14-2.053c-1.355-.854-3.204-1.28-5.545-1.28h-5.914v17.787h6.918c2.5 0 4.506-.817 6.02-2.453 1.514-1.635 2.27-3.805 2.27-6.508 0-2.15-.537-3.981-1.61-5.493m-7.182 10.427h-1.927v-9.734h1.954c1.373 0 2.428.43 3.168 1.287.74.857 1.11 2.073 1.11 3.647 0 3.2-1.435 4.8-4.305 4.8M18.637 0L4.09 3.81.081 18.439l5.014 5.148L0 28.65l3.773 14.693 14.484 4.047 5.096-5.064 5.014 5.147 14.547-3.81 4.008-14.63-5.013-5.146 5.095-5.063L43.231 4.13 28.745.083l-5.094 5.063zM9.71 6.624l7.663-2.008 3.351 3.44-4.887 4.856zm16.822 1.478l3.405-3.383 7.63 2.132-6.227 6.187zM4.672 17.238l2.111-7.705 6.125 6.288-4.886 4.856zm29.547-1.243l6.227-6.189 1.986 7.74-3.404 3.384zm-15.502-.127l4.887-4.856 4.807 4.936-4.886 4.856zm-7.814 7.765l4.886-4.856 4.81 4.936-4.888 4.856zm15.503.127l4.886-4.856L36.1 23.84l-4.887 4.856zM4.57 29.927l3.406-3.385 4.807 4.937-6.225 6.186zm14.021 1.598l4.887-4.856 4.808 4.936-4.886 4.856zm15.502.128l4.887-4.856 3.351 3.439-2.11 7.705zm-24.656 8.97l6.226-6.189 4.81 4.936-3.406 3.385zm16.843-1.206l4.886-4.856 6.126 6.289-7.662 2.007z"></path></g></svg>`,
          projectId: projectId,
          traits: [
            {
              label: 'Tenant from page binded collection',
              name: 'is-tenant-from-record',
              changeProp: 1,
              type: 'checkbox',
            },
          ],
          script: function () {
            const projectId = '{[ projectId ]}';
            const itemPriceField = '{[ data-item-price ]}';
            const itemDescField = '{[ data-item-desc ]}';
            let isTenantFromRecord = '{[ is-tenant-from-record ]}';
            isTenantFromRecord = isTenantFromRecord.toString();
            isTenantFromRecord = isTenantFromRecord.trim();
            let localStorage = window.localStorage;
            const accessToken = localStorage.getItem('token');
            console.log('accessToken', accessToken);
            const fluidPayEl = this;
            const identifyType = fluidPayEl.getAttribute('data-gjs-type');
            if (!identifyType) {
              serverUrl = getBackendServerUrl();
            }
            const fluidPayBtn = document.getElementById('fluid-pay-btn');
            const headers = {
              'Content-Type': 'application/json',
              'x-project-id': projectId,
            };
            if (accessToken) {
              headers['authorization'] = accessToken;
            }
            const currentTenant = isLoggedInUser() ? fetchCurrentTenantJson() : '';
            const currentTenantId = currentTenant ? currentTenant.uuid : '';
            if (currentTenantId) {
              headers['x-tenant-id'] = currentTenantId;
            }
            console.log(
              '%c headers',
              'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
              headers,
            );
            const header = {
              headers: headers,
            };
            let pageCollectionName = '';
            let pageItemId = '';
            if (isTenantFromRecord) {
              const queryString = window.location.search;
              console.log('queryString test', queryString);
              const pathArray = window.location.pathname.split('/');
              console.log('pathArray test', pathArray);
              pageCollectionName = pathArray[pathArray.length - 2];
              pageItemId = pathArray[pathArray.length - 1];
            }
            console.log('pageCollectionName', pageCollectionName);
            console.log('pageItemId', pageItemId);
            const processFluidPaymentToServer = (resp, fluidPayBtn, tenantDetail) => {
              console.log(
                '%c resp processFluidPaymentToServer',
                'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                resp,
              );
              let collectionName = fluidPayBtn.attributes['data-collection-id'];
              if (!collectionName) {
                toastr.error('Please bind Collection Name', 'Error');
                return;
              }
              collectionName = collectionName ? collectionName.value : '';
              let itemUuid = fluidPayBtn.attributes['data-item-id'];
              if (!itemUuid) {
                toastr.error('Please bind Product Field', 'Error');
                return;
              }
              itemUuid = itemUuid ? itemUuid.value : '';
              console.log(
                '%c itemPrice',
                'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                itemPriceField,
              );
              console.log(
                '%c collectionName',
                'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                collectionName,
              );
              let successPayment = false;
              let paymentObj = null;
              switch (resp.status) {
                case 'success':
                  fluidPayBtn.disabled = true;
                  fluidPayBtn.innerHTML = 'Processing Payment';
                  paymentObj = {
                    paymentResponseToken: resp.token,
                    collectionName,
                    itemUuid,
                    itemPriceField,
                    itemDescField,
                  };
                  if (resp.user) {
                    paymentObj.paymentResponseUser = resp.user;
                  }
                  console.log(
                    '%c paymentObj',
                    'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                    paymentObj,
                  );
                  successPayment = true;
                  break;
                case 'error':
                  console.log(
                    '%c resp.msg',
                    'color:red;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                    resp.msg,
                  );
                  break;
                case 'validation':
                  console.log(
                    '%c resp.invalid',
                    'color:green;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                    resp.invalid,
                  );
                  if (resp.invalid && resp.invalid.length > 0) {
                    if (resp.invalid[0] === 'exp') {
                      fluidPayBtn.innerHTML = 'Card is expired';
                    }
                  }
                  break;
              }
              console.log('successPayment processFluidPaymentToServer', successPayment);
              console.log('tenantDetail processFluidPaymentToServer', tenantDetail);
              if (successPayment) {
                if (isTenantFromRecord && tenantDetail) {
                  paymentObj.tenantUuid = tenantDetail.tenantUuid;
                  paymentObj.isTenantFromRecord = tenantDetail.isTenantFromRecord;
                }
                console.log('paymentObj processFluidPaymentToServer', paymentObj);
                processSuccessFluidPay(paymentObj);
              }
            };
            const processSuccessFluidPay = (paymentObj) => {
              console.log('paymentObj processSuccessFluidPay', paymentObj);
              axios
                .post(`${serverUrl}fluid-pay/process-payment`, paymentObj, header)
                .then(({ data }) => {
                  const { successURL, fluidResponse } = data;
                  const { id, merchant_id } = fluidResponse;
                  localStorage.setItem('fluid_payment_id', id);
                  localStorage.setItem('fluid_merchant_id', merchant_id);
                  window.sessionStorage.setItem('fluid_payment_id', id);
                  window.sessionStorage.setItem('fluid_merchant_id', merchant_id);
                  if (successURL) {
                    window.location.href = successURL;
                  }
                })
                .catch((error) => {
                  console.log('err', error);
                  if (error.response) {
                    console.log('error.response', error.response);
                    const { status, failedURL, data } = error.response;
                    console.log('data', data);
                    if (status == 403) {
                      fluidPayBtn.innerHTML = 'Please login to pay';
                    }
                    if (status === 400) {
                      const { message } = data;
                      toastr.error(message, 'Error');
                    } else {
                      fluidPayBtn.innerHTML = data;
                    }
                    console.log('failedURL', failedURL);
                    if (failedURL) {
                      window.location.href = failedURL;
                    }
                  } else if (error.request) {
                    console.log(error.request);
                  } else {
                    console.log('Error', error.message);
                  }
                });
            };
            console.log('serverUrl', serverUrl);
            console.log('isTenantFromRecord', isTenantFromRecord);
            if (serverUrl) {
              console.log(
                'isTenantFromRecord &&(isTenantFromRecord === "true" ||isTenantFromRecord === true)',
                isTenantFromRecord &&
                  (isTenantFromRecord === 'true' || isTenantFromRecord === true),
              );
              console.log(
                '(isTenantFromRecord === "true" || isTenantFromRecord === true)',
                isTenantFromRecord === 'true' || isTenantFromRecord === true,
              );
              console.log('isTenantFromRecord === "true"', isTenantFromRecord === 'true');
              console.log('isTenantFromRecord === true', isTenantFromRecord === true);
              if (
                isTenantFromRecord &&
                (isTenantFromRecord === 'true' || isTenantFromRecord === true)
              ) {
                console.log('>><<<<Making API Call>>>><<<<>>> isTenantFromRecord ', serverUrl);
                doProcessForCollectionData(pageItemId, pageCollectionName).then((result) => {
                  console.log('result test', result);
                  let tenantId = result ? result.itemData.tenantId : null;
                  if (!tenantId) {
                    console.log("No Collection Item found so can't process fluid payment");
                  } else {
                    const { uuid } = tenantId[0];
                    console.log('tenant UUID', uuid);
                    if (!uuid) {
                      console.log("This tenant doesn't have tenant uuid so don't pay");
                    } else {
                      console.log('I have everything please process');
                      // Else use 2 routes
                      axios
                        .post(
                          `${serverUrl}fluid-pay/api-key`,
                          { tenantUuid: uuid, isTenantFromRecord },
                          header,
                        )
                        .then((response) => {
                          console.log('>>>>>>>>>>>>>>>>>>>>>>>>');
                          const { data } = response;
                          console.log('Creating Form with data', data);
                          const { isShipping, isBilling, isUser, api_key } = data;
                          const settings = {};
                          console.log('settings', settings);
                          if (isUser) {
                            settings.user = {
                              showInline: true,
                              showName: true,
                              showEmail: true,
                              showPhone: true,
                              showTitle: true,
                            };
                          }
                          console.log('settings', settings);
                          if (isBilling) {
                            settings.billing = { show: true, showTitle: true };
                          }
                          console.log('settings', settings);
                          if (isShipping) {
                            settings.shipping = { show: true, showTitle: true };
                          }
                          console.log('settings', settings);
                          let fluidExample = new Tokenizer({
                            url: '',
                            apikey: data.api_key,
                            container: '#fluid-pay-container',
                            submission: (resp) => {
                              console.log(
                                '%c resp',
                                'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                                resp,
                              );
                              console.log('processFluidPaymentToServer calling');
                              processFluidPaymentToServer(resp, fluidPayBtn, {
                                tenantUuid: uuid,
                                isTenantFromRecord,
                              });
                            },
                            settings,
                            onLoad: () => {
                              console.log('Iframe has loaded');
                              fluidPayBtn.disabled = false;
                            },
                            onPaymentChange: (type) => {
                              console.log(
                                '%c type',
                                'color:red;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                                type,
                              );
                            },
                            validCard: (card) => {
                              console.log(
                                '%c card',
                                'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                                JSON.stringify(card),
                              );
                              const { isValid } = card;
                              console.log(
                                '%c isValid',
                                'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                                isValid,
                              );
                              if (isValid) {
                                console.log('I will set onclick to fluidExample Submit');
                                console.log('fluidPayBtn', fluidPayBtn);
                                fluidPayBtn.innerHTML = 'Pay!';
                                fluidPayBtn.disabled = false;
                                fluidPayBtn.onclick = function () {
                                  fluidExample.submit();
                                };
                              } else {
                                fluidPayBtn.disabled = true;
                              }
                            },
                          });
                        })
                        .catch((error) => {
                          console.log('Getting Error error:', error);
                          if (error.response) {
                            if (error.response.status == 403) {
                              fluidPayBtn.innerHTML = 'Please login to Pay';
                            }
                          } else if (error.request) {
                            console.log(error.request);
                          } else {
                            console.log('Error', error.message);
                          }
                        });
                    }
                  }
                });
              } else {
                console.log('>><<<<Making API Call>>>><<<<>>> ', serverUrl);
                axios
                  .post(`${serverUrl}fluid-pay/api-key`, {}, header)
                  .then((response) => {
                    console.log('>>>>>>>>>>>>>>>>>>>>>>>>');
                    const { data } = response;
                    console.log('Creating Form with data', data);
                    const { isShipping, isBilling, isUser, api_key } = data;
                    const settings = {};
                    console.log('settings', settings);
                    if (isUser) {
                      settings.user = {
                        showInline: true,
                        showName: true,
                        showEmail: true,
                        showPhone: true,
                        showTitle: true,
                      };
                    }
                    console.log('settings', settings);
                    if (isBilling) {
                      settings.billing = { show: true, showTitle: true };
                    }
                    console.log('settings', settings);
                    if (isShipping) {
                      settings.shipping = { show: true, showTitle: true };
                    }
                    console.log('settings', settings);
                    let fluidExample = new Tokenizer({
                      url: '',
                      apikey: data.api_key,
                      container: '#fluid-pay-container',
                      submission: (resp) => {
                        console.log(
                          '%c resp',
                          'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                          resp,
                        );
                        console.log('processFluidPaymentToServer calling');
                        processFluidPaymentToServer(resp, fluidPayBtn);
                      },
                      settings,
                      onLoad: () => {
                        console.log('Iframe has loaded');
                        fluidPayBtn.disabled = false;
                      },
                      onPaymentChange: (type) => {
                        console.log(
                          '%c type',
                          'color:red;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                          type,
                        );
                      },
                      validCard: (card) => {
                        console.log(
                          '%c card',
                          'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                          JSON.stringify(card),
                        );
                        const { isValid } = card;
                        console.log(
                          '%c isValid',
                          'color:yellow;border:1px solid red;text-shadow:2px 2px black;padding:3px;font-size:14px;',
                          isValid,
                        );
                        if (isValid) {
                          console.log('I will set onclick to fluidExample Submit');
                          console.log('fluidPayBtn', fluidPayBtn);
                          fluidPayBtn.innerHTML = 'Pay!';
                          fluidPayBtn.disabled = false;
                          fluidPayBtn.onclick = function () {
                            fluidExample.submit();
                          };
                        } else {
                          fluidPayBtn.disabled = true;
                        }
                      },
                    });
                  })
                  .catch((error) => {
                    console.log('Getting Error error:', error);
                    if (error.response) {
                      if (error.response.status == 403) {
                        fluidPayBtn.innerHTML = 'Please login to Pay';
                      }
                    } else if (error.request) {
                      console.log(error.request);
                    } else {
                      console.log('Error', error.message);
                    }
                  });
              }
            }
          },
        },
        async init() {
          const collectionName = findParentCollection(this, config);
          if (collectionName) {
            const collectionResponse = await getCollectionFields(collectionName, collections);
            if (collectionResponse) {
              const collectionFieldOptions = await fieldTraitTextContentOptions(
                collectionResponse,
                collections,
              );
              if (collectionFieldOptions) {
                this.addTrait({
                  label: 'Price Field',
                  name: 'data-item-price',
                  title: 'price',
                  type: 'data-fluid-pay-trait',
                  options: collectionFieldOptions,
                });
                this.addTrait({
                  label: 'Description Field',
                  name: 'data-item-desc',
                  title: 'description',
                  type: 'data-fluid-pay-trait',
                  options: collectionFieldOptions,
                });
              }
              const { fields } = collectionResponse;
              const collectionReferenceFields =
                fields && fields.length > 0
                  ? fields.filter((crd) => crd.type === FieldTypes.reference.id)
                  : [];
              this.setAttributes({
                selectedCollectionData: JSON.stringify(collectionReferenceFields),
              });
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {},
    }),
  });
};
